import { useState } from 'react';
import useResizeObserver from 'use-resize-observer';

export const useOverflowTrigger = <T extends HTMLElement>() => {
  const [isHorizontalOverflow, setIsHorizontalOverflow] = useState(false);
  const [isVerticalOverflow, setIsVerticalOverflow] = useState(false);
  const { ref } = useResizeObserver<T>({
    onResize: () => {
      const isHorizontalOverflow = (ref.current?.scrollWidth ?? 0) > (ref.current?.clientWidth ?? 0);
      const isVerticalOverflow = (ref.current?.scrollHeight ?? 0) > (ref.current?.clientHeight ?? 0);
      setIsHorizontalOverflow(isHorizontalOverflow);
      setIsVerticalOverflow(isVerticalOverflow);
    },
  });
  return { elementRef: ref, isHorizontalOverflow, isVerticalOverflow };
};
